import { Flow } from 'flow-to-typescript-codemod';
import { SelectFilterChip } from 'common/ui/Chip/SelectFilterChip';
import type { FilterChipItem } from 'common/ui/Chip/SelectFilterChip';
import { STUDY_RELEVANCE } from '../useStudyRelevance';
import type { TStudyRelevance } from '../useStudyRelevance';

const STUDY_ITEMS: ReadonlyArray<FilterChipItem<TStudyRelevance>> = Object.freeze([
  {
    label: 'Study',
    value: STUDY_RELEVANCE.Study,
  },
  {
    label: 'Global',
    value: STUDY_RELEVANCE.Global,
  },
]);

export type StudyFilterChipDropdownProps = {
  selected: TStudyRelevance;
  disabled?: boolean;
  onSelect: (selected: TStudyRelevance) => void;
};

export const StudyFilterChipDropdown: Flow.AbstractComponent<
  StudyFilterChipDropdownProps,
  undefined
> = (props) => {
  return (
    <SelectFilterChip
      size="xs"
      selected={props.selected}
      disabled={props.disabled}
      onSelect={props.onSelect}
      onClear={() => props.onSelect(STUDY_RELEVANCE.All)}
      items={STUDY_ITEMS}
      placeholder="Relevance"
    />
  );
};
